//----------------------
// check rune integrity
//----------------------
/*
  Applies rune integrity rules (pure function)
    @param {Object} rune - the rune to check
    @param {String} changedField - the field that was just changed
    @returns {Object} - Object with updated rune and list of changes made
 */
export default function checkRuneIntegrity({ rune, changedField = null } = {}) {
  if (!rune) return { updated: rune, changes: [] }

  const updated = { ...rune }
  const changes = []
  //===============================================================
  // Rule 0: if already integrated elsewhere -> starter = false, integrated = false
  //===============================================================
  if (updated.already_integrated === true && updated.starter !== false) {
    updated.starter = false
    changes.push({ key: 'starter', value: false, reason: 'already_integrated' })
  }
  if (updated.already_integrated === true && updated.integrated !== false) {
    updated.integrated = false
    changes.push({ key: 'integrated', value: false, reason: 'already_integrated' })
  }
  if (updated.integrated !== true) {
    if (updated.integrated_character !== null && updated.integrated_character !== undefined) {
      updated.integrated_character = null
      changes.push({ key: 'integrated_character', value: null, reason: 'not_integrated' })
    }
    if (updated.integrated_character_id !== null && updated.integrated_character_id !== undefined) {
      updated.integrated_character_id = null
      changes.push({ key: 'integrated_character_id', value: null, reason: 'not_integrated' })
    }
    if (updated.integrated_character_name) {
      updated.integrated_character_name = ''
      changes.push({ key: 'integrated_character_name', value: '', reason: 'not_integrated' })
    }
  }
  //===============================================================
  // Rule 1: if starter = true → integrated = true
  //===============================================================
  if (
    updated.already_integrated !== true &&
    updated.starter === true &&
    updated.integrated !== true
  ) {
    updated.integrated = true
    changes.push({ key: 'integrated', value: true, reason: 'starter_enforced' })
  }
  return { updated, changes }
}
